import React from 'react';
import { BREAKDOWN } from './constants';

export const ScoreRing = ({ score, meta, testid }) => {
  const r = 22;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative h-14 w-14 shrink-0" data-testid={testid}>
      <svg viewBox="0 0 56 56" className="h-14 w-14 -rotate-90">
        <circle cx="28" cy="28" r={r} fill="none" stroke="currentColor" strokeWidth="5" className="text-slate-200 dark:text-slate-700" />
        <circle cx="28" cy="28" r={r} fill="none" stroke={meta.ring} strokeWidth="5" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - score / 100)} style={{ transition: 'stroke-dashoffset 600ms ease' }} />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-sm font-bold tabular-nums">{Math.round(score)}</span>
    </div>
  );
};

export const Breakdown = ({ b, meta, testid }) => (
  <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 sm:grid-cols-4" data-testid={testid}>
    {BREAKDOWN.map(({ key, label, weight }) => (
      <div key={key}>
        <div className="flex justify-between text-[11px] text-slate-500"><span>{label} <span className="opacity-60">{weight}%</span></span><span className="tabular-nums">{b[key]}</span></div>
        <div className="mt-0.5 h-1.5 rounded-full bg-slate-200 dark:bg-slate-700">
          <div className={`h-1.5 rounded-full ${meta.bar}`} style={{ width: `${b[key]}%`, transition: 'width 500ms ease' }} />
        </div>
      </div>
    ))}
  </div>
);
